import React, { useEffect, useState } from "react";
import DynamicTable from "../../components/ui/tables/table";
import { useDispatch } from "react-redux";
import {
  tagsDeleteAction,
  tagsMultiDeleteAction,
  tagsTableAction,
} from "../../redux/actions/tags-action";
import { removeUnderScore } from "../../components/helper-functions/helper/helper";
import { useLocation } from "react-router";
import { contactEnquiryTableAction } from "../../redux/actions/contact-enquiry-action";
import dayjs from "dayjs";
import NotificationComponent from "../../components/notificationComponent";

const ContactEnquiriesTable = () => {
  const location = useLocation();
  const [inputValue, setInputValue] = useState("");
  const dispatch = useDispatch();
  const [tags, setTags] = useState([]);
  const [pagination, setPagination] = useState();
  const [currentPage, setCurrentPage] = useState(
    parseInt(location?.state?.page) ? parseInt(location?.state?.page) : 1
  );
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [sortConfig, setSortConfig] = useState({ sort_by: "", sort_order: "" });
  useEffect(() => {
    setLoading(true);
    dispatch(
      contactEnquiryTableAction(
        {
          page: currentPage,
          size: 10,
          search: inputValue,
          sort: sortConfig
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, inputValue, reload, sortConfig]);

  const onSuccess = (data) => {
    setLoading(false);
    setTags(data?.data?.contactUs);
    setPagination(data?.data?.pagination);
  };
  const onError = (data) => {
    setLoading(false);
  };
  const tableData = tags.map((item) => ({
    id: item?.id,
    code: item?.code,
    name: removeUnderScore(item?.name),
    phone_number: item?.phone_number ?? "--",
    createdAt: dayjs(item?.createdAt).format(
      "DD MMMM YYYY, hh:mm:ss A"
    ) ?? "--",
    Action: ["/contact-enquiry/view/"],
  }));

  return (
    <div className=" col-lg-11 col-12 px-lg-0 px-2 ps-lg-4 pt-4 mb-5 ">
      <NotificationComponent />
      <DynamicTable
        tabletitle="Contact Enquiries"
        modalText={'tag'}
        placeholder={"Search contact enquiry id, product id, name & mobile number "}
        tableHeading={tableTagsHeader}
        tablebody={tableData}
        setInputValue={setInputValue}
        inputValue={inputValue}
        pagination={pagination}
        setCurrentPage={setCurrentPage}
        singleDeleteAction={tagsDeleteAction}
        multiDeleteAction={tagsMultiDeleteAction}
        setLoading={setLoading}
        loading={loading}
        setReload={setReload}
        reload={reload}
        id_name={"contact_id"}
        sortConfig={sortConfig}
        setSortConfig={setSortConfig}
        createButton={false}
      />
    </div>
  );
};
export default ContactEnquiriesTable;

const tableTagsHeader = [
  { label: "Contact Enquiry ID", value: "code" },
  { label: "Name", value: "name" },
  { label: "Mobile Number", value: "phone_number" },
  { label: "Created Date & Time", value: "createdAt" },
  { label: "Actions", value: "Actions" },
];
